import React from 'react';
import UnderConstruction from '../../components/common/underconstruction/UnderConstruction';

const Faq = () => {
    return (
        <UnderConstruction />
    );
};

export default Faq;